import { Base, emitter } from '@codesuma/baseline'
import theme from '../../services/theme'
import style from './index.module.css'

// A round button floated in a page's bottom-right corner. It shows the icon of the
// theme you'd switch *to* — a moon while light, a sun while dark — and uses
// currentColor so it inherits the page foreground. Re-renders on any theme change
// (so both pages' toggles stay in sync if one is flipped).
const MOON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>'
const SUN =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></svg>'

export const ThemeToggle = () => {
    const base = Base('button') as any
    base.addClass(style.base)

    const render = () => { base.el.innerHTML = theme.get() === 'dark' ? SUN : MOON }
    render()

    base.el.addEventListener('click', () => theme.toggle())
    emitter.on('theme', render)

    return base
}
